import { render, staticRenderFns } from "./Ot-Management.vue?vue&type=template&id=741e3100&scoped=true"
import script from "./Ot-Management.vue?vue&type=script&lang=js"
export * from "./Ot-Management.vue?vue&type=script&lang=js"
import style0 from "./Ot-Management.vue?vue&type=style&index=0&id=741e3100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e3100",
  null
  
)

export default component.exports